module.exports = __webpack_public_path__ + "img/11_76.f2839661.png";